import { styled } from '@acko-tech/building-blocks.ui.common';

export const CardWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border: 1px solid #e7e7f0;
    border-radius: 16px;
    padding: 20px;
    margin: 8px 0;
`;

export const PlanTitle = styled.div`
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    color: #040222;
    margin-bottom: 8px;
`;

export const BenefitFlex = styled.div`
    display: flex;
    margin: 8px 0;
`;

export const GreenTickFlex = styled.div`
    display: flex;
    flex: 1;
    align-items: self-start;
`;

export const BenefitText = styled.div`
    display: flex;
    flex: 10;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #5b5675;
`;

export const SeeDetails = styled.div`
    display: flex;
    font-weight: 600;
    font-size: 12px;
    line-height: 15px;
    color: #1c73e8;
    margin-top: 8px;
`;

export const Hr = styled.div`
    width: calc(100% + 40px);
    height: 0px;
    border: 1px solid #e7e7f0;
    margin-top: 16px;
    transform: translateX(-20px);
`;

export const BottomFlex = styled.div`
    display: flex;
    margin-top: 20px;
`;

export const PriceWrapper = styled.div`
    display: flex;
    flex: 1;
`;

export const PriceDivFlex = styled.div`
    display: flex;
    flex-direction: column;
`;

export const GSTText = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #5b5675;
`;

export const BuyFlex = styled(PriceWrapper)`
    justify-content: flex-end;
`;

export const PriceFlex = styled.div`
    display: flex;
    font-weight: 700;
    font-size: 22px;
    line-height: 32px;
    align-items: center;
    color: #040222;
`;

export const StrikedPriceFlex = styled.div`
    display: flex;
    font-weight: 700;
    font-size: 16px;
    line-height: 32px;
    align-items: center;
    color: #7a7690;
    text-decoration: line-through;
    margin-right: 4px;
`;

export const SlashYear = styled.div`
    display: flex;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    align-items: center;
    color: #5b5675;
    margin-left: 4px;
`;

export const PaymentModeSection = styled.div`
    margin-top: 16px;
`;

export const PaymentModeLabel = styled.div`
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #040222;
    margin-bottom: 8px;

    span {
        color: #e53935;
    }
`;

export const PaymentModeOptions = styled.div`
    display: flex;
    gap: 12px;
`;

export const PaymentModeButton = styled.button<{ isSelected: boolean }>`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid
        ${({ isSelected }) => (isSelected ? '#1c73e8' : '#e7e7f0')};
    border-radius: 8px;
    background: ${({ isSelected }) => (isSelected ? '#f0f7ff' : '#ffffff')};
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: ${({ isSelected }) => (isSelected ? '#1c73e8' : '#040222')};
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: #1c73e8;
    }
`;

export const BuyFlexWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
`;

export const HelperText = styled.div`
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: #5b5675;
    margin-top: 4px;
`;
